'use client';

import React from 'react';

const rings = [
  { size: 120, duration: '8s', color: 'rgba(0,240,255,0.15)', delay: '0s', borderWidth: 1 },
  { size: 200, duration: '12s', color: 'rgba(168,85,247,0.12)', delay: '-3s', borderWidth: 1 },
  { size: 300, duration: '18s', color: 'rgba(0,240,255,0.08)', delay: '-6s', borderWidth: 1 },
  { size: 420, duration: '25s', color: 'rgba(168,85,247,0.06)', delay: '-10s', borderWidth: 1 },
  { size: 560, duration: '35s', color: 'rgba(0,240,255,0.05)', delay: '-15s', borderWidth: 1 },
  { size: 720, duration: '50s', color: 'rgba(168,85,247,0.04)', delay: '-22s', borderWidth: 1 },
  { size: 900, duration: '70s', color: 'rgba(0,240,255,0.03)', delay: '-30s', borderWidth: 1 },
  { size: 1100, duration: '90s', color: 'rgba(168,85,247,0.02)', delay: '-40s', borderWidth: 1 },
];

const particles = Array.from({ length: 30 }, (_, i) => ({
  id: `particle-${i}`,
  x: Math.floor((i * 37 + 13) % 100),
  y: Math.floor((i * 53 + 7) % 100),
  size: (i % 3) + 1,
  opacity: 0.1 + (i % 5) * 0.08,
  duration: 3 + (i % 7),
  delay: (i % 5) * 0.6,
}));

export default function BlackholeBackground() {
  return (
    <div className="blackhole-bg">
      {/* Deep space gradient */}
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse 80% 80% at 50% 50%, rgba(13,13,43,0.9) 0%, rgba(5,5,16,1) 70%)',
        }}
      />
      {/* Blackhole core */}
      <div
        className="absolute"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(0,0,0,1) 40%, rgba(0,240,255,0.2) 70%, transparent 100%)',
          boxShadow: '0 0 40px rgba(0,240,255,0.15), 0 0 80px rgba(168,85,247,0.1)',
        }}
      />
      {/* Vortex rings */}
      {rings?.map((ring, i) => (
        <div
          key={`vortex-ring-${i}`}
          className="absolute"
          style={{
            top: '50%',
            left: '50%',
            width: `${ring?.size}px`,
            height: `${ring?.size}px`,
            marginTop: `-${ring?.size / 2}px`,
            marginLeft: `-${ring?.size / 2}px`,
            borderRadius: '50%',
            border: `${ring?.borderWidth}px solid ${ring?.color}`,
            animation: `vortexSpin ${ring?.duration} linear infinite`,
            animationDelay: ring?.delay,
            borderTopColor: 'transparent',
            borderRightColor: 'transparent',
          }}
        />
      ))}
      {/* Ambient glow blobs */}
      <div
        className="absolute"
        style={{
          top: '20%',
          left: '15%',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(0,240,255,0.04) 0%, transparent 70%)',
          filter: 'blur(40px)',
          animation: 'vortexPulse 8s ease-in-out infinite',
        }}
      />
      <div
        className="absolute"
        style={{
          bottom: '20%',
          right: '15%',
          width: '400px',
          height: '400px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(168,85,247,0.04) 0%, transparent 70%)',
          filter: 'blur(60px)',
          animation: 'vortexPulse 10s ease-in-out infinite',
          animationDelay: '-4s',
        }}
      />
      {/* Floating particles */}
      {particles?.map((p) => (
        <div
          key={p?.id}
          className="absolute rounded-full"
          style={{
            left: `${p?.x}%`,
            top: `${p?.y}%`,
            width: `${p?.size}px`,
            height: `${p?.size}px`,
            background: p?.id?.includes('1') ? 'rgba(0,240,255,0.6)' : 'rgba(168,85,247,0.6)',
            opacity: p?.opacity,
            animation: `float ${p?.duration}s ease-in-out infinite`,
            animationDelay: `${p?.delay}s`,
          }}
        />
      ))}
      {/* Scan line effect */}
      <div
        className="absolute left-0 right-0 pointer-events-none"
        style={{
          height: '2px',
          background: 'linear-gradient(90deg, transparent, rgba(0,240,255,0.08), transparent)',
          animation: 'scanLine 8s linear infinite',
          animationDelay: '-2s',
        }}
      />
    </div>
  );
}